import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import NavBar from "./nav";

class PageHeader extends Component {
    render() {
        return (
            <header className="App header">
                <div className="navBarHeader">
                    <NavBar title="Portal halley.app" />
                </div>
            </header>
        )
    }
}

export default withTranslation('translation')(PageHeader);
